<template>
  <div>
    <Collapse v-model="value" @on-change="collapseChange">
      <Panel v-for="(item, index) in dataArr" :key="index" :name="item.instApplyFlowId">
        {{ config.applyTypeMap[item.applyType] }}
        <p slot="content">
          <Timeline>
              <TimelineItem v-for="(ele, i) in item.finishTaskUserList" :key="i" color="green">
                <Icon type="md-checkmark" slot="dot" />
                  <p class="approvalPersonStyle">{{ ele.auditRoleData }}<span class="approvalTimeStyle">{{ ele.auditTime }}</span></p>
                  <p>{{ ele.auditUserNameData }}</p>
                  <!-- 加签 -->
                  <p v-if="ele.auditUserNameDataMap">{{ ele.auditUserNameDataMap }}</p>
                  <!-- 转交 -->
                  <p v-if="ele.deliver" class="noteStyle">{{ ele.deliver }}</p>
                  <!-- 原因 -->
                  <p class="noteStyle">{{ ele.auditNote }}</p>
                  <!-- 抄送人数据 -->
                  <p>{{ ele.copyerLength }}</p>
                  <p>{{ ele.copyerPerson }}</p>
              </TimelineItem>
              <div v-if="item.willTaskNodeList && item.willTaskNodeList instanceof Array && item.willTaskNodeList.length > 0">
                <TimelineItem v-for="(ele, i) in item.willTaskNodeList" :key="i"  color="green" :class="ele.taskStatus == 0 ? '' : 'currentFlowStyle'">
                  <Icon v-if="ele.taskStatus == 1" type="md-arrow-round-forward" slot="dot" />
                  <!-- 审批中 -->
                  <div v-if="ele.taskStatus == 1">
                    <p class="approvalPersonStyle">{{ ele.tplNodeName }}</p>
                    <p class="willApprovalUserNameStyle">{{ ele.taskUserList.length }}人{{ config.taskExecModeMap[ele.taskExecMode] }}（{{ config.taskStatusMap[ele.taskStatus] }}）</p>
                    <span v-for="(eleChild, iChild) in ele.taskUserList" :key="iChild" class="willApprovalUserNameStyle">{{ eleChild.auditUserName }}</span>
                  </div>
                  <!-- 将要审批 -->
                  <div v-else>
                    <p class="approvalPersonStyle">{{ ele.approvalPerson }}</p>
                    <p class="willApprovalUserNameStyle">{{ ele.tplNodeName }}</p>
                    <p>{{ ele.approvalUsers }}</p>
                  </div>
                </TimelineItem>
              </div>
          </Timeline>
        </p>
      </Panel>
    </Collapse>
  </div>
</template>

<script>
import { config } from './config';
export default {
  data () {
    return {
      config
    };
  },
  props: {
    value: Array,
    dataArr: {
      type: Array,
      default: () => []
    },
    selfUserId: String // 当前用户id
  },
  watch: {
    dataArr: {
      handler(val) {
        // 循环里面的数据
        if (val && val instanceof Array && val.length > 0) {
          val.forEach(item => {
            // 已经完成的流程
            if (item.finishTaskUserList && item.finishTaskUserList instanceof Array && item.finishTaskUserList.length > 0) {
              item.finishTaskUserList.forEach(ele => {
                // 0：未开始，1：审批中, 2:审核通过，3：审核不通过，4：已抄送，5：撤回，6：撤销， 7: 修改，8: 撤销修改， 9：回退上一节点或指定节点, 10：打回申请人，11：自动通过，12：自动拒绝 ，13：已转交，14：加签， 15：评论， 98:去除重复， 99：已不需要执行（被其他用户执行, 竞争执行或有一人不通过或撤回、回退、等）
                // 如果是评论人，标题更更改为：xxx发起了评论
                if (ele.auditUserId == this.selfUserId) { ele.auditUserName = '我'; }
                if (ele.auditResult == 15) {
                  ele.auditRoleData = `${ele.auditUserId == this.selfUserId ? '我' : ele.auditUserName}发起了评论`;
                  ele.auditUserNameData = '';
                } else if ([9, 13, 14].includes(ele.auditResult)) {
                  // 9回退 13转交 14加签
                  let taskUserData;
                  if (ele.taskUserData) { taskUserData = JSON.parse(ele.taskUserData); }
                  ele.auditRoleData = ele.auditRole;
                  if (ele.auditResult == 9) {
                    const taskUserNames = taskUserData.exeUserList.map(item => item.userName).join(' ');
                    ele.auditUserNameData = `${ele.auditUserName}${config.auditResultMap[ele.auditResult]}（${taskUserNames} ${taskUserData.exeUserList.length}人${config.taskExecModeMap[taskUserData.taskExecMode] || ''}）`;
                  } else if (ele.auditResult == 13) {
                    if (ele.auditUserId && taskUserData.opUser && ele.auditUserId != taskUserData.opUser.userId) {
                      ele.auditUserNameData = `管理员（${config.auditResultMap[ele.auditResult]}）`;
                      ele.deliver = `管理员 ${taskUserData.opUser.userName} 将${ele.auditRole}从 ${ele.auditUserName} 转交给 ${taskUserData.toUser.userName}`;
                    } else {
                      ele.auditUserNameData = `${ele.auditUserName}（${config.auditResultMap[ele.auditResult]}）`;
                      ele.deliver = `${ele.auditUserName} 已将${ele.auditRole}转交给 ${taskUserData.toUser.userName}`;
                    }
                  } else {
                    const addAuditSeqObj = { 1: '添加前加签人', 2: '添加后加签人' };
                    ele.auditUserNameData = `${ele.auditUserName}（${config.auditResultMap[ele.auditResult]}）`;
                    ele.auditUserNameDataMap = `${taskUserData.addAuditSeq ? addAuditSeqObj[taskUserData.addAuditSeq] : '添加加签人'}:${taskUserData.exeUserList.map(item => item.userName).join(' ')}`;
                  }
                } else {
                  ele.auditRoleData = ele.auditRole;
                  if (ele.auditResult != 5 && ele.notifyUsers && ele.notifyUsers instanceof Array) {
                    if (ele.notifyUsers.length > 0) {
                      ele.copyerLength = `已抄送${ele.notifyUsers.length}人`;
                      ele.copyerPerson = `${ele.notifyUsers.map(item => {
                          return item.userName;
                        }).join(' ')}`;
                    } else {
                      ele.copyerLength = '已抄送0人';
                    }
                  }
                  if (ele.auditRole != '抄送人') {
                    ele.auditUserNameData = `${ele.auditUserName}${`（${config.auditResultMap[ele.auditResult]}）`}`;
                  }
                }
              });
            }
            // 正在进行和将要进行的流程
            if (item.willTaskNodeList && item.willTaskNodeList instanceof Array && item.willTaskNodeList.length > 0) {
              item.willTaskNodeList.forEach(ele => {
                if (ele.taskStatus == 0 && [2, 3].includes(ele.taskExecMode)) {
                  // 如果是将要审批的流程 & 是会签或者或签，需要再后面加（全部通过）或者（任意一人通过）
                  ele.taskExecMode = `-${ele.taskExecMode}`;
                }
                if (ele.taskNodeType == 4) {
                  // 如果是抄送节点
                  if (ele.taskUserList && ele.taskUserList instanceof Array && ele.taskUserList.length > 0) {
                    // 如果抄送节点有抄送人
                    ele.approvalPerson = `抄送${ele.taskUserList[0].notifyUsers.length}人`;
                    ele.approvalUsers = ele.taskUserList[0].notifyUsers.map(item => item.userName).join(' ');
                  } else {
                    ele.approvalPerson = '抄送0人';
                  }
                  // ele.users =
                } else {
                  ele.approvalPerson = `${ele.taskUserList.length}人${config.taskExecModeMap[ele.taskExecMode]}`;
                  ele.approvalUsers = ele.taskUserList.map(item => item.auditUserName).join(' ');
                }
              });
            }
          });
        } else {
          alert('流程状态出错');
        }
      },
      deep: true
    }
  },
  methods: {
    collapseChange(e) {
      this.$emit('input', e);
    }
  }
};
</script>

<style scoped>
.approvalPersonStyle{
  font-size: 20px;
  font-weight: 600;
}
.approvalTimeStyle{
  font-size: 16px;
  float: right;
  font-weight: 400;
}
.noteStyle{
  color: #5a8bfd;
}
.remarkPersonStyle{
  font-weight: 600;
}
.currentFlowStyle{
  padding: 8px 0;
  border:  1px solid #ddd;
  border-radius: 10px;
}
.willApprovalUserNameStyle{
  margin-right: 6px;
  font-size: 16px;
  font-weight: 500;
}
</style>
